import styled from "styled-components";
import { Flex } from "antd";

export const RemoveLatex = styled(Flex)`
  margin-left: 8px;
  &:hover {
    cursor:pointer;
  } 
`

export const ModalTop = styled(Flex)`
  margin-bottom: 12px;
  align-items:center;
`


export const ModalLatexText = styled(Flex)`
  justify-content:center;
  margin-top: 12px;
`

export const EditBtn = styled(Flex)`
  margin-left: 12px;
    &:hover {
    cursor:pointer;
  } 
`

export const MyDirectiveDiv = styled.div`
    display: inline-block;
    position: relative;
  `